export const TEST = 1;
export const SCORM = 2;
export const VIDEO = 3;
export const PRESENTATION = 4;
export const ARTICLE = 5;
export const TYPEFORM = 6;
export const TILDA = 7;
export const EXISTING_MATERIAL = 8;
export const FILE = 9;
export const CHECK_LIST = 10;
